import moment from 'moment'
import { firestore } from 'firebase/app'

export function convertFirebaseTimestampToDateAndTime(timestamp) {
  if (timestamp) {
    const dt = moment(timestamp.toDate()).format()
    return {
      date: dt.substr(0, 10),
      time: dt.substr(11, 5)
    }
  }
  return {
    date: null,
    time: null
  }
}

export function convertDateAndTimeToFirebaseTimestamp(date, time) {
  if (date) {
    if (!time) {
      time = '00:00'
    }
    return firestore.Timestamp.fromDate(moment(date + ' ' + time).toDate())
  }
  return undefined
}

export default {
  convertFirebaseTimestampToDateAndTime,
  convertDateAndTimeToFirebaseTimestamp
}